import { WeatherType, GAME_CONFIG } from '../types';
import { RNG } from '../utils/RNG';

const WEATHER_TYPES: WeatherType[] = ['clear', 'rain', 'perfect', 'heat_wave', 'storm'];
const WEATHER_WEIGHTS = [50, 20, 10, 10, 10];
const CHANGE_CHANCE = 0.2;

export class Weather {
  currentWeather: WeatherType = 'clear';
  daysLeft: number = 0;
  private rng: RNG;

  constructor(rng: RNG) {
    this.rng = rng;
  }

  advanceDay(): WeatherType {
    if (this.daysLeft > 0) {
      this.daysLeft--;
      return this.currentWeather;
    }

    if (this.rng.chance(CHANGE_CHANCE)) {
      this.currentWeather = this.rng.weightedPick(WEATHER_TYPES, WEATHER_WEIGHTS);
      this.daysLeft = this.rng.range(1, 3) - 1; // subtract 1 because today counts
    } else {
      this.currentWeather = 'clear';
      this.daysLeft = 0;
    }

    return this.currentWeather;
  }

  getTimeMultiplier(): number {
    return GAME_CONFIG.weatherEffects[this.currentWeather].timeMultiplier;
  }

  getDescription(): string {
    return GAME_CONFIG.weatherEffects[this.currentWeather].description;
  }

  setWeather(type: WeatherType, days: number): void {
    this.currentWeather = type;
    this.daysLeft = days;
  }

  canWork(): boolean {
    return this.currentWeather !== 'storm';
  }
}
